import {
  IAdminOrganizationDetails,
  IAdminOrganizationsSearchResult,
} from '@interfaces/adminOrganizations';

export const searchAdminOrganizationsPayload = {
  pagination: {
    page: 0,
    pageSize: 1000,
  },
  search: '',
  sort: {
    active: '',
    direction: '',
  },
};

export const updateOrganizationInListIsActive = (
  data: IAdminOrganizationsSearchResult,
  organizationId: number,
  isActive: boolean,
) => ({
  ...data,
  tableData: data.tableData.map(item =>
    item.id === organizationId ? { ...item, isActive } : item,
  ),
});

export const updateOrganizationDetailsIsActive = (
  organization: IAdminOrganizationDetails,
  isActive: boolean,
) => ({
  ...organization,
  isActive,
});
